import { useSetRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';
import ConfirmDialog from 'components/dialogs/ConfirmDialog';
import useModal from 'hooks/useModal';
import spinner from 'recoil/atoms/spinner';
import Api from 'utils/api';


const useCarPhotos = () => {
    const {t} = useTranslation('cars');
    const {showModal, hideModal} = useModal();
    const setSpinner = useSetRecoilState(spinner);

    const downloadPhotos = (id: number) => {
        setSpinner(true);
        Api.photos.download(id)
            .then(() => setSpinner(false))
    };

    const confirmDeletePhoto = (paths: string[]) => showModal(ConfirmDialog,
        {
            description: t('it_cant_be_undone'),
        },
        {
            title: t('confirm_delete_photo'),
            fullScreen: false,
        })
        .then(() => Api.photos.remove(paths))
        .finally(hideModal);

    return {
        addPhotos: Api.photos.add,
        getPhotos: Api.photos.get,
        move: Api.photos.move,
        rotate: Api.photos.rotate,
        downloadPhotos,
        confirmDeletePhoto,
    }
};

export default useCarPhotos;
